
import * as session from './auth_session';
import * as registration from './auth_registration';

export const authService = {
  ...session,
  ...registration
};
